export default __webpack_public_path__ + "static/media/flatpy.8be7f71b.svg";